//import createBrowserHistory from 'history/createBrowserHistory';
import { createBrowserHistory } from 'history';
//import ConfigApp from 'services/configApp';

export default createBrowserHistory({
  basename: '', //ConfigApp.ApiUrl
});
